import { SeoMapper } from '@search/router/src';

export const bathroomMapper = new SeoMapper('bathroomMapper', {
    'razdelnyj-sanuzel': 'PARTED',
    'sovmeshhennyj-sanuzel': 'COMBINED',
    'hz-kakoi-sanuzel': 'UNKNOWN',
    'neskolko-sanuzlov': 'SEVERAL'
} as const);
